import { Outlet } from 'react-router-dom'
import GNB from './GNB'
import MusicToggleButton from 'components/MusicToggleButton'
import styles from './layout.module.scss'

const Layout = () => {
  return (
    <>
      <GNB />
      <div className={styles.musicToggleRail}>
        <MusicToggleButton />
      </div>
      <main className={styles.pageContainer}>
        <Outlet />
      </main>
      {/* TODO: footer 추가 */}
    </>
  )
}

export default Layout
